module.exports = __webpack_public_path__ + "img/map_2-f1ad3f.png";